// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"-GOvIt","menuName":"_1exhGy","current":"ALulv7","hero":"_2uR0pb","pageName":"_3tfOGT","text":"_2fIDzx"};